import React, { useState } from 'react';
import { Row, Col, Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import EditLandlordIntegration from './edit-landlord-integration';
import useStyles from '../../style.js';

const LandlordIntegration = ({ landlord, getLandlord, updateLandlord }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { systemProvider, systemProviderComment } = landlord;
  const descriptionsArr = [
    {
      label: t('cms.landlord.detail.system_provider.label'),
      value: systemProvider ? landlord.systemProvider.toUpperCase() : undefined,
    },
    {
      label: t('cms.landlord.detail.system_provider_comment.label'),
      value: systemProviderComment,
    },
    {
      label: t('cms.landlord.detail.system_external_id.label'),
      value: systemProvider ? landlord.systemExternalId : undefined,
    },
  ];
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            title={t('cms.landlord.detail.landlord_integration.title')}
            extra={
              <span
                className={classes.formOutLineIcon}
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t('cms.sepcial_offer.edit.btn')}
              </span>
            }
            className={classes.cardWrapper}
            style={{ border: 'none' }}
          >
            <Descriptions column={1} className={classes.descriptionWrapper}>
              {descriptionsArr.map(description => (
                <Descriptions.Item
                  label={description.label}
                  key={`reconciliation_setting${description.label}`}
                >
                  {description?.value ?? '-'}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Card>
        </Col>
      </Row>

      <EditLandlordIntegration
        landlord={landlord}
        getLandlord={getLandlord}
        updateLandlord={updateLandlord}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </>
  );
};
LandlordIntegration.propTypes = {
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};

export default LandlordIntegration;
